(function(){

  const VARIANT_CLASSES = {
    info: 'border border-blue-200 bg-blue-50 text-blue-900',
    success: 'border border-green-200 bg-green-50 text-green-900',
    warning: 'border border-amber-200 bg-amber-50 text-amber-900',
    error: 'border border-red-200 bg-red-50 text-red-900'
  };

  const BASE_CLASSES = 'rounded-md shadow-lg px-3 py-2 text-sm flex items-start gap-3 bg-white';

  class RCToast extends HTMLElement {

    constructor(){
      super();
      this._opts = null;
      this._timerId = null;
      this._remaining = 0;
      this._root = this; // light DOM for Tailwind to apply
      this._styleConfig = null;
    };

    connectedCallback(){
      // Remove any previously attached listeners to avoid stacking
      this.removeEventListener('mouseenter', this._pauseTimer);
      this.removeEventListener('mouseleave', this._resumeTimer);
      // If configured via attributes, render now; otherwise wait for configure()
      if(!this._opts){
        const message = this.getAttribute('message') || '';
        const type = this.getAttribute('type') || 'info';
        const dismissable = this.hasAttribute('dismissable');
        const timeAttr = this.getAttribute('time');
        const time = timeAttr ? Number(timeAttr) : 4000;
        this.configure({ message, type, dismissable, time });
      } else {
        this._render();
      };
    };

    disconnectedCallback(){
      this._clearTimer();
      this.replaceChildren();
    };

    configure(opts){
      const { message = '', type = 'info', dismissable = true, time = 4000, devMessage, styleConfig } = opts || {};
      this._opts = { message, type, dismissable, time, devMessage };
      this._styleConfig = styleConfig || null;
      if(this.isConnected) this._render();
    };

    _render(){
      const { message, type, dismissable, time } = this._opts;
      this._clearTimer();
      // Remove listeners to avoid stacking
      this.removeEventListener('mouseenter', this._pauseTimer);
      this.removeEventListener('mouseleave', this._resumeTimer);
      // Apply classes or inline styles based on styleConfig
      if(this._styleConfig && (this._styleConfig.bgColor || this._styleConfig.textColor)){
        this.className = `${BASE_CLASSES}`;
        this.style.backgroundColor = this._styleConfig.bgColor || '';
        this.style.color = this._styleConfig.textColor || '';
        this.style.border = '1px solid currentColor';
        if(typeof this._styleConfig.paddingPx === 'number') this.style.padding = `${this._styleConfig.paddingPx}px`;
        if(typeof this._styleConfig.radiusPx === 'number') this.style.borderRadius = `${this._styleConfig.radiusPx}px`;
      } else {
        this.className = `${BASE_CLASSES} ${VARIANT_CLASSES[type] || VARIANT_CLASSES.info}`;
        // Reset inline styles if previously set
        this.style.backgroundColor = '';
        this.style.color = '';
        this.style.border = '';
        this.style.padding = '';
        this.style.borderRadius = '';
      };
      if(type === 'error') this.setAttribute('role','alert');
      else this.setAttribute('role','status');
      this.replaceChildren();
      const content = document.createElement('div');
      content.className = 'flex-1';
      content.textContent = message;
      this._root.appendChild(content);
      if(dismissable){
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'ml-3 text-gray-500 hover:text-gray-700 focus:outline-none';
        closeBtn.setAttribute('aria-label','Dismiss');
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', () => this.remove());
        this._root.appendChild(closeBtn);
      };
      this._remaining = typeof time === 'number' && time > 0 ? time : 0;
      this.addEventListener('mouseenter', this._pauseTimer);
      this.addEventListener('mouseleave', this._resumeTimer);
      this._resumeTimer();
    };

    _pauseTimer = () => { 
      if(this._timerId){ 
        clearTimeout(this._timerId); 
        this._timerId = null; 
      };
     };

    _resumeTimer = () => {
      if(this._remaining > 0 && !this._timerId){
        this._timerId = setTimeout(() => this.remove(), this._remaining); 
      }; 
    };

    _clearTimer(){
      if(this._timerId){
        clearTimeout(this._timerId); 
        this._timerId = null; 
      };
    };
  };

  if(!customElements.get('rc-toast')){
    customElements.define('rc-toast', RCToast);
  };

})();